import React from 'react';
import News from "../views/NewsPage/index";

const Article = () => <News/>

export default Article;